import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  IconButton,
  Chip,
  Button,
  Divider,
  Paper,
  Tooltip,
  Switch,
  Badge,
  useTheme,
  Stack,
  LinearProgress,
} from "@mui/material";
import {
  TrendingUp,
  TrendingDown,
  AccessTime,
  AccountBalance,
  CompareArrows,
  Info,
  CheckCircle,
  Warning,
  ArrowUpward,
  ArrowDownward,
} from "@mui/icons-material";
import moment from "moment";

const TransactionComparisonCard = ({ data }) => {
  const theme = useTheme();
  const [showDetails, setShowDetails] = useState(false);
  const [selectedPeriod, setSelectedPeriod] = useState("monthly");
  const [transactionData, setTransactionData] = useState([]);
  useEffect(() => {
    let productData = [];
    if (data.length) {
      data.forEach((item, i) => {
        productData.push({
          id: i,
          type: `Record ${i + 1}`,
          amount: item?.amount,
          transactionType: item?.tranaction_type,
          statusType: item.status,
          status: data?.status == "Completed" ? "success" : "warning",
          orderCode: item.order_code,
          merchantCode: item?.merchant_reference_code,
          startDate: moment(new Date(item?.start_date)).format("D-MM-YYYY"),
          initiatedAmount: item?.initiatedAmount,
          intiatedAmountTooltip: "Initiated amount",
        });
      });
    }
    setTransactionData([...productData]);
  }, [data]);
  console.log(transactionData, "vv");
  const getStatusColor = (status) => {
    return {
      success: theme.palette.success.main,
      warning: theme.palette.warning.main,
      error: theme.palette.error.main,
    }[status];
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "INR",
    }).format(amount);
  };

  const calculateChange = (current, previous) => {
    const percentage = ((current - previous) / previous) * 100;
    return percentage.toFixed(1);
  };

  const TransactionCard = ({ data }) => (
    <Card
      elevation={3}
      className="transaction-comapre-card"
      sx={{
        position: "relative",
        transition: "transform 0.3s ease-in-out",
        borderRadius: "12px",
        "&:hover": {
          transform: "translateY(-8PX)",
          background: " #cbecefb0",
        },
        height: "270px",
        // width:""
      }}
    >
      <CardContent>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Typography variant="h6" color="#495a69">
            {data.type}
          </Typography>
          <Chip
            icon={data.statusType !== "Expired" ? <CheckCircle /> : <Warning />}
            label={`${data.statusType}`}
            color={data.statusType !== "Expired" ? "success" : "warning"}
            size="small"
          />
        </Box>

        <Typography variant="h4" sx={{ mb: 2, color: "#495a69" }}>
          {formatCurrency(data.amount)}
        </Typography>

        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          {data.transactionType === "up" ? (
            <TrendingUp color="success" />
          ) : (
            <TrendingDown color="error" />
          )}
          <Typography variant="body2" color="text.secondary" sx={{ ml: 1 }}>
            {/* {calculateChange(data.amount, data.previousAmount)}% vs previous{" "} */}
            {/* {selectedPeriod} */}
          </Typography>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Stack spacing={2}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="body2" color="text.secondary">
              Order Code: {data.orderCode}
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography variant="body1" fontWeight="medium">
                {data.initiatedAmount}
              </Typography>
              <Tooltip title={`Previous: ${data.intiatedAmountTooltip}`}>
                <IconButton size="small">
                  <Info fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="body2" color="text.secondary">
              Merchant Code: {data.merchantCode}
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              {/* <AccessTime fontSize="small" sx={{ mr: 1 }} /> */}
              <Typography variant="body1">Start: {data.startDate}</Typography>
            </Box>
          </Box>

          {showDetails && (
            <Box sx={{ mt: 2 }}>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                Categories
              </Typography>
              <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                {data.categories.map((category) => (
                  <Chip
                    key={category}
                    label={category}
                    size="small"
                    variant="outlined"
                  />
                ))}
              </Box>
            </Box>
          )}
        </Stack>

        <LinearProgress
          variant="determinate"
          value={data.statusType}
          sx={{
            mt: 2,
            height: 6,
            borderRadius: 3,
            bgcolor: theme.palette.grey[200],
            "& .MuiLinearProgress-bar": {
              borderRadius: 3,
              bgcolor:
                data.statusType == "Expired"
                  ? theme.palette.warning.main
                  : theme.palette.success.main,
            },
          }}
        />
      </CardContent>
    </Card>
  );

  return (
    <Box sx={{ maxWidth: "auto", mx: "0px", p: 1, mt: "4px", mb: "55px" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography
          variant="h5"
          sx={{ display: "flex", alignItems: "center", gap: 1 }}
        >
          <CompareArrows />
          Transaction Analysis
        </Typography>
      </Box>

      <Box
        className=""
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
          gap: 10,
        }}
      >
        {transactionData.map((transaction) => (
          <TransactionCard key={transaction.id} data={transaction} />
        ))}
      </Box>
    </Box>
  );
};

export default TransactionComparisonCard;
